<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// 新增模块

export default {
  name: "App",
  mounted() {
    console.log("2@@@@@@@@@@@@@@@@@@@@@@@@@")
    document.addEventListener("keydown", (event) => {
      if ((event.ctrlKey||event.shiftKey) && event.key.toLowerCase() == "d") {
        this.$eapi.invoke("system:open-debug");
        // window.ELECTRONAPI.invoke("system:create-webview");
      }
    });
    //绑定事件
    this.$store.dispatch("bindevent/bind");
  },
  methods: {},
};
</script>

<style src="./assets/com.css"></style>

<style src="./assets/main.css"></style>
<style lang="scss">
body,
html {
  height: 100%;
}
#app {
  height: 100%;
}
</style>
